import DetailViewProvider from "../../../../common/providers/detailViewProvider";
import DetailView from "../../../../common/models/detailView/detailView";
import ListView from "../../../../common/models/listViews/listView";
import ListViewProvider from "../../../../common/providers/listViewProvider";
import ObjectModelEntry from "~/models/objectModelEntries/objectModelEntry";
import {DetailViewMode} from "../../enums/detailViewMode";
import PublishedListView from "~/models/listViews/publishedListView";

export default function () {
  const baseStore = {
    namespaced: true,
    state: {
      detailViewProvider: new DetailViewProvider(DetailView, 'detail_view', 'detail_views'),
      listViewProvider: new ListViewProvider(ListView, 'list_view', 'list_views'),
      listViewForPreview: null,
      detailViewMode: DetailViewMode.Default,
    },
    mutations: {
      setListViewForPreview(state, {listView}) {
        state.listViewForPreview = listView;
      },
      setDetailViewMode(state, {mode}) {
        state.detailViewMode = mode
      }
    },
    actions: {
      async fetchAssociatedListView({commit, state, getters}, {organizationId, detailViewId, listViewId, entryId}: { organizationId: string, detailViewId: string, listViewId: string, entryId: string}) {
        return new Promise((resolve, reject) => {
          state.detailViewProvider.fetchAssociatedListView({
            organizationId,
            detailViewId,
            listViewId,
            entryId,
          }).then(([data, status, xhr]) => {
            let listView = PublishedListView.repo.find(data.list_view.client_id) as PublishedListView;
            if (!listView) {
              listView = new PublishedListView();
              listView.addToRepo();
            }
            listView.loadFromJson(data.list_view);
            resolve(listView);
          })
        });
      },
      async fetchHistory({commit, state, getters}, {organizationId, detailViewId, entryId, modelHistoryId, fetchIdx, initialFetch}: { organizationId: string, detailViewId: string, entryId: string, modelHistoryId: string, fetchIdx: number, initialFetch: boolean}) {
        return new Promise((resolve, reject) => {
          state.detailViewProvider.fetchHistory({
            organizationId,
            detailViewId,
            entryId,
            modelHistoryId,
            fetchIdx,
            initialFetch
          }).then(([data, status, xhr]) => {
            resolve(data);
          })
        });
      },
      setListViewForPreview({commit, state, getters}, {listView}) {
        commit('setListViewForPreview', {listView})
      },
      async fetchAssociatedFakeEntries({commit, state, getters}, {listView}: {listView: ListView}): Promise<any> {
        return new Promise(async (resolve, reject) => {
          const [data, status, xhr] = await state.listViewProvider.entries(listView, {fake: true});
          resolve({entries: data.entries, totalCount: data.total_count});
        });
      },

      async fetchAssociatedEntries({ commit, state, getters }, { listView, limit, relationId, detailViewId, parentEntry, inverse, highlightedEntryId }: { listView: ListView, limit?: number, relationId?: string, detailViewId?: string, parentEntry?: ObjectModelEntry, inverse?: boolean, highlightedEntryId?: string }): Promise<any> {
        const [data] = await state.listViewProvider.entries(
          listView, {
          fake: false,
          limit,
          relationId: relationId,
          detailViewId: detailViewId,
          parentEntryId: parentEntry && parentEntry.id,
          inverse: inverse || false,
          highlightedEntryId: highlightedEntryId
        })
        return [data.entries, data.relation, data.total_count];
      },
      fetchEntry({ state }, { detailViewId, entryId }: { detailViewId: string, entryId: string }) {
        return state.detailViewProvider.entryShow({ detailViewId, entryId });
      },
    },
  };

  return window.AppConfig.mergeJson(
    baseStore,
  );
}